import React from "react";
import "./AdvertisementCard.css";
import { Card } from "antd";
import GoogleAd from "./GoogleAd";

const AdvertisementCard = ({ transformationAds }) => {
  return (
    <div className="ad-fixed">
      <div className="ad-card">
        <h3 className="ad-title">Advertisement</h3>
        {transformationAds ? (
          <div className="trial-card">
            <div className="trial-header">
              <span className="trial-emoji">🧘</span>
              <h2>
                21-Day
                <br />
                Transformation
              </h2>
            </div>

            <p className="trial-subtext">
              Master your daily flow and build a lasting habit.
            </p>

            <div className="trial-highlight">
              <h3>START FREE!</h3>
              <p>(Includes full access to beginner modules)</p>
            </div>

            <p className="trial-footer">
              Guided by certified Master Instructors.
            </p>

            <button className="trial-btn">Claim Your Free Trial</button>
          </div>
        ) : (
          <div className="ad-space"><GoogleAd /></div>
        )}
      </div>
    </div>
  );
};

export default AdvertisementCard;
